var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamicNews"},[_c('div',{staticClass:"dynamicNewsCon"},[_c('p',[_vm._v("进行中商机："),_c('span',[_vm._v(_vm._s(_vm.newsInfo.goingBussinessNumber)+"个")])]),_vm._v(" "),_c('p',[_vm._v("商机被查看次数："),_c('span',[_vm._v(_vm._s(_vm.newsInfo.viewNumber)+"次")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a71bad2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamicNews/index.vue
// module id = null
// module chunks = 